import React from 'react';
import cls from 'classnames';

import { ReactComponent as ArrowRight } from '../../../assets/svg/icons/arrow-right-short.svg';
import { IconComp } from '../IconComponent';
import { SKBreadcrumbs, ISKBreadcrumbs } from '../Breadcrumbs';
import { useBreakpoint } from '../../../hooks/useBreakpoint';

interface IPageHeaderLink {
  label: string;
  url: string;
}

export interface IPageHeader {
  background: 'kiwi' | 'lemon' | 'grape-500' | 'onion' | 'pomelo' | 'grape-400';
  title: string;
  description: string;
  breadcrumbs?: ISKBreadcrumbs;
  link?: IPageHeaderLink;
  sticker?: React.ReactType;
  stickerWidth?: number;
  notTopBorder?: boolean;
}

export const PageHeader: React.FC<IPageHeader> = (props) => {
  const { background, title, description, breadcrumbs, link, sticker, stickerWidth, notTopBorder } = props;
  const isBiggerThanMobile = useBreakpoint('48em');
  return (
    <div
      className={cls('border-b border-cloud-900', {
        'bg-kiwi-400': background === 'kiwi',
        'bg-lemon-400': background === 'lemon',
        'bg-grape-500': background === 'grape-500',
        'bg-onion-200': background === 'onion',
        'bg-pomelo-400': background === 'pomelo',
        'bg-grape-400': background === 'grape-400',
        'border-t': !notTopBorder,
      })}
    >
      <div className="app-container mx-auto flex flex-wrap min-h-17.75 sm-and-below:px-2 md:px-0 items-center justify-between">
        <div className="flex flex-col gap-y-4">
          {breadcrumbs && <SKBreadcrumbs links={breadcrumbs.links} className="mb-4" />}
          <div>
            <h4 className="text-display-lg text-cloud-900 mb-1">{title}</h4>
            <div dangerouslySetInnerHTML={{ __html: description }}></div>
          </div>
          {link && (
            <a className="flex items-center gap-x-1" href={link.url} target="_blank" rel="noreferrer">
              <span className="text-base text-cloud-900">{link.label}</span>
              <IconComp icon={ArrowRight} size={20} />
            </a>
          )}
        </div>
        {sticker && isBiggerThanMobile && <IconComp icon={sticker} size={stickerWidth} />}
      </div>
    </div>
  );
};
